import { firstNameOf } from './team-chat-messages';

/** Above the owner's live Littlebird answers, so a member never takes them for their own Littlebird */
export function OwnerLittlebirdLabel({
  ownerName,
  className,
}: {
  readonly ownerName: string;
  readonly className?: string;
}) {
  return (
    <p className={className}>
      <span className="text-xs font-medium text-foreground-subtle">
        {firstNameOf(ownerName)}&apos;s Littlebird
      </span>
    </p>
  );
}
